import { render, staticRenderFns } from "./SettingsInplace.vue?vue&type=template&id=282bdd29&scoped=true"
import script from "./SettingsInplace.vue?vue&type=script&lang=js"
export * from "./SettingsInplace.vue?vue&type=script&lang=js"
import style0 from "./SettingsInplace.vue?vue&type=style&index=0&id=282bdd29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282bdd29",
  null
  
)

export default component.exports